export const NavigationRoutes = {
  authentication: {
    SIGNING: 'sign-in',
    LOCK_SCREEN: 'lock-screen',
    FORGOT_PASSWORD: 'forgot-password',
    RESET_PASSWORD: 'reset-password',
    AUTHENTICATION: 'authentication',
    LOGOUT: 'logout',
  },
  dashboard: {
    DASHBOARD: 'dashboard',
  },
  home: {
    home: 'home',
  },
  userRoutes: {
    USER_LIST: 'users-list',
    USER_ADD: 'users-add',
    USER: 'user',
    USER_EDIT: 'user-edit',
  },
  rolesAndPermission: {
    ROLES_LIST: 'roles-list',
    ROLES_ADD: 'roles-add',
    ROLES: 'roles',
    ROLES_EDIT: 'roles-edit',
  },
  company: {
    COMPANY_LIST: 'company-list',
    COMPANY_ADD: 'company-add',
    COMPANY: 'company',
    COMPANY_EDIT: 'company-edit',
    COMPANY_ARGS: 'id_company',
  },
  projects: {
    PROJECT_LIST: 'project-list',
    PROJECT_ADD: 'project-add',
    PROJECT_CLIENT_LIST: 'project-client-list',
    PROJECT_CLIENT_ADD: 'project-client-add',
    PROJECT: 'project',
    PROJECT_EDIT: 'project-edit',
    PROJECT_PERSONAL_INFORMATION: 'personal-information',
    PROJECT_CONFIGURATIONS: 'projects-configuration',
    COMPANY_ARGS: 'id_company',
  },
  profileListRoutes: {
    PROFILE: 'settings',
    CHANGE_PASSWORD: 'change-password',
    ACCOUNT_SETTINGS: 'account-settings',
  },
  layout: {
    HOME: 'home-layout',
  },
};
